import React from 'react';
import { MapPin } from 'lucide-react';

interface PresetLocation {
  name: string;
  lng: number;
  lat: number;
  zoom: number;
}

const PRESETS: PresetLocation[] = [
  { name: 'Sydney CBD', lng: 151.2093, lat: -33.8688, zoom: 14 },
  { name: 'Blue Mountains', lng: 150.3119, lat: -33.7129, zoom: 13 },
  { name: 'Daintree', lng: 145.4185, lat: -16.17, zoom: 14 },
  { name: 'Brisbane Hills', lng: 153.0251, lat: -27.4698, zoom: 14 },
];

interface PresetLocationsProps {
  onSelect: (lng: number, lat: number, zoom: number) => void;
}

export const PresetLocations: React.FC<PresetLocationsProps> = ({ onSelect }) => {
  return (
    <div className="flex flex-wrap gap-1.5">
      {PRESETS.map((preset) => (
        <button
          key={preset.name}
          onClick={() => onSelect(preset.lng, preset.lat, preset.zoom)}
          className="flex items-center gap-1.5 rounded-md bg-slate-800/80 px-2.5 py-1.5 text-xs font-medium text-slate-300 backdrop-blur-sm border border-slate-600/40 transition-colors hover:bg-slate-700/70 hover:text-white hover:border-slate-500/50"
          title={`Fly to ${preset.name}`}
        >
          <MapPin className="h-3 w-3 text-sky-400" />
          {preset.name}
        </button>
      ))}
    </div>
  );
};
